import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const MarkEmailReadIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"mark_email_read"} ref={ref}/>
});

MarkEmailReadIcon.displayName = "MarkEmailReadIcon";
